<script lang="ts">
const price = 399
</script>
<script setup lang="ts">
const { showIntercom } = useSubscriptionProcessContext()

const { formatCurrency } = useIntl()


</script>

<template>
  <div class="flex flex-col gap-5 rounded-xl border border-gray-200 p-5 md:flex-row md:gap-10">
    <div class="flex flex-col gap-3 md:w-1/2 md:gap-5">
      <p class="text-2xl font-bold">
        {{ $t('subscriptionCustomPlanCard.title', { price: formatCurrency(price, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }) }}
      </p>
      <p class="text-gray-600">
        {{ $t('subscriptionCustomPlanCard.description') }}
      </p>
    </div>
    <div class="flex flex-col justify-center md:w-1/2">
      <DTButton
        variant="blue"
        @click="showIntercom"
      >
        {{ $t('subscriptionCustomPlanCard.cta') }}
      </DTButton>
    </div>
  </div>
</template>
